// components/CMS/StatisticsCards.js
import React from "react"
import CMSRender from "aldoo-ra/CMS/cms-render"
import Typography from "aldoo-ra/Typography"
import { url } from "aldoo-ra/CMS/url"

const StatisticsCards = () => {
  return (
    <div className="w-full px-[16px] md:px-px1_l xl:px-px1_xl">
      {/* Blue Banner */}
      <div className="flex w-full lg:max-w-w2_l xl:max-w-w2_xl md:h-[340px] lg:h-[218px] items-center justify-center bg-gradient_statistics_banner rounded-[50px] py-4 mx-auto">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 w-full px-[20px]">
          <CMSRender
            contentType="ProductStatisticsBanner"
            match={ { "content.id" : "statistics_banner_1" } }
            renderItem={(banner) => {
              return (banner?.cards || []).map((card, id) => (
                <div
                  key={id}
                  className="flex flex-row items-center justify-center py-4 lg:py-0"
                >
                  {card.icon ? (
                    <img
                      src={url(card.icon)}
                      alt={card.title}
                      className="w-[180px] lg:w-full lg:max-w-[180px] xl:max-w-[230px] h-[60px] lg:h-auto lg:max-h-[60px] xl:max-h-[76px] mx-auto"
                    />
                  ) : (
                    <div className="flex flex-col w-full h-[84px] md:h-auto items-center justify-center space-y-2 text-center">
                      {/* Gradient title color */}
                      <Typography 
                        variant="h2" 
                        className="bg-clip-text text-transparent bg-gradient-to-t from-grad_blue_dk to-grad_blue_lt"
                      >
                        {card.title}
                      </Typography>

                      <Typography 
                        variant="body1"
                        className="h-[60px]"
                      >
                        {card.info}
                      </Typography>
                    </div>
                  )}
                  {/* Dividers */}
                  {id < banner.cards.length - 1 && (
                    <div className="lg:border-r lg:border-gray_500 lg:h-[75px]" />
                  )}
                </div>
              ))
            }}
          />
        </div>
      </div>
    </div>
  )
}

export default StatisticsCards
